/*
* @author    Agence Dn'D <contact@dnd.fr>
* @license   https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link      https://www.dnd.fr/
*/

const initFinishTabs = (tabsEl) => {
    if (tabsEl.dataset.finishInit) return;
    tabsEl.dataset.finishInit = 'true';

    const picker = tabsEl.closest('variant-picker');
    if (!picker) return;

    const buttons = tabsEl.querySelectorAll('[data-finish-tab]');

    const applyFilter = (filter) => {
        const labels = picker.querySelectorAll('.opt-label[data-finish]');
        const visibleInputs = [];

        labels.forEach((label) => {
            const input = document.getElementById(label.getAttribute('for'));
            const finish = label.getAttribute('data-finish') || '';
            const show = filter === 'all' || finish === filter;

            label.style.display = show ? '' : 'none';

            if (input) {
                input.disabled = !show;
                if (show) visibleInputs.push(input);
            }
        });

        const hasVisibleChecked = visibleInputs.some((input) => input.checked);

        if (!hasVisibleChecked && visibleInputs.length) {
            visibleInputs[0].checked = true;
            visibleInputs[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
    };

    buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
            buttons.forEach((b) => {
                const active = b === btn;
                b.classList.toggle('is-active', active);
                b.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            applyFilter(btn.getAttribute('data-finish-tab'));
        });
    });
};

document.querySelectorAll('.finish-tabs').forEach(initFinishTabs);